export function getCourseAccessLevelInformation(course) {
  const { freeCount, signInExercises } = course.syllabus.reduce(
    (acc, syllabus) => {
      syllabus.modules.forEach(({ accessLevel, name }) => {
        if (accessLevel === 'free') acc.freeCount++;
        if (accessLevel === 'signedIn') acc.signInExercises.push(`Module ${name}`);
      });
      return acc;
    },
    { freeCount: 0, signInExercises: [] }
  );
  return { freeCount, signInExercises };
}

export function getFirstIncompleteLevel(course, language) {
  for (const [syllabusIndex, syllabusObject] of course.syllabus.entries()) {
    for (const [moduleIndex, module] of syllabusObject.modules.entries()) {
      let isExerciseCompleted = module.exercise.isCompletedInAnyLanguage;
      if (language === 'any' && isExerciseCompleted) continue;
      else if (language === 'any' && !isExerciseCompleted) {
        let levelObjectWithLanguage = {};
        for (const language in course.languages) {
          for (const [levelIndex, level] of module?.exercise?.languagesCompleted[language].entries()) {
            if (levelObjectWithLanguage[levelIndex]) continue;
            if (level.isCompleted) levelObjectWithLanguage[levelIndex] = true;
            else levelObjectWithLanguage[levelIndex] = false;
          }
        }
        for (const lockedLevel in levelObjectWithLanguage) {
          if (!levelObjectWithLanguage[lockedLevel]) {
            return {
              syllabusIndex,
              moduleIndex,
              levelIndex: Number(lockedLevel),
            };
          }
        }
      } else {
        for (const [levelIndex, level] of module?.exercise?.languagesCompleted[language]?.entries()) {
          let isCompleted = level.isCompleted;
          if (!isCompleted) {
            return {
              syllabusIndex,
              moduleIndex,
              levelIndex,
            };
          }
        }
      }
    }
  }
}
